const getTotal = (Dents,key) => {
    let total = 0;
    total =
      Dents &&
      Dents.reduce((acc, num) => {
        if (num[key]) {
          return (
            parseFloat(acc) +
            parseFloat(num[key])
          );
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return total;
}

export default getTotal;